import Axios from "helpers/Interceptor";

export interface MessageUsage {
    messages_used: number;
    message_limit: number;
    tier: string;
    reset_date?: string;
    usage_percentage: number;
}

export interface MessageLimit {
    id: number;
    tier_name: string;
    monthly_message_limit: number;
    created_at: string;
    updated_at: string;
}

export interface ApiResponse<T> {
    success: boolean;
    data?: T;
    message?: string;
    error?: string;
}

/**
 * Get message usage for a specific brand or free tier defaults
 * @param brandId - The brand ID to get usage for (optional)
 * @returns Promise with message usage data
 */
export const getMessageUsage_api = async (brandId?: number): Promise<MessageUsage> => {
    try {
        const config = brandId ? {
            headers: {
                'brand-id': brandId.toString()
            }
        } : {};
        
        const response = await Axios.get('/message-limits/usage', config);
        return response.data;
    } catch (error: any) {
        console.error('Error fetching message usage:', error);
        throw error;
    }
};

/**
 * Get all message limits (admin only)
 * @returns Promise with all message limits
 */
export const getAllMessageLimits_api = async (): Promise<MessageLimit[]> => {
    try {
        const response = await Axios.get('/message-limits/limits');
        return response.data;
    } catch (error: any) {
        console.error('Error fetching message limits:', error);
        throw error;
    }
};

/**
 * Update message limit for a specific tier (admin only)
 * @param tierName - The tier name to update
 * @param monthlyLimit - The new monthly limit
 * @returns Promise with update result
 */
export const updateMessageLimit_api = async (tierName: string, monthlyLimit: number): Promise<MessageLimit> => {
    try {
        const response = await Axios.put(`/message-limits/limits/${tierName}`, {
            monthly_message_limit: monthlyLimit
        });
        return response.data;
    } catch (error: any) {
        console.error('Error updating message limit:', error);
        throw error;
    }
};